import ErrorLogo from "@/assets/error.svg";
import { ReloadIcon } from "@radix-ui/react-icons";

const UnexpectedError = ({ className }: { className?: string }) => {
  return (
    <div
      className={`flex flex-col items-center p-16 w-full justify-center gap-3 ${className}`}
    >
      <img src={ErrorLogo} alt="" />
      <div className="font-bold text-[19px] leading-[28px] text-center text-brand-primary-new mb-1">
        Something went wrong
      </div>
      <div className="font-inter text-center text-base font-normal leading-[21.78px] text-[#617390] w-[40%]">
        It looks like something unexpected happened. Don't worry, a quick reload should
        get things back on track.
      </div>
      <button
        className="rounded-full flex items-center justify-center gap-2 border border-border-gray border-opacity-50 px-4 py-2 mt-4 text-[#1F3861] text-[16px]"
        onClick={() => window.location.reload()}
      >
        <ReloadIcon />
        Reload
      </button>
    </div>
  );
};

export default UnexpectedError;
